import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const TextArea = styled.div`
    width: '100%';
    margin-left: '20px';
    color: 'rgba(0,0,0,0.87)';
    letter-spacing: '0.25px';
    line-height: '27px';
`;

const TextWrapper = ({ children }) => {
  return <TextArea>{children}</TextArea>;
};

TextWrapper.propTypes = {
  children: PropTypes.node,
};

export default TextWrapper;
